import {
    comMapping
} from '../../../../../util/Function/comMapping.js'

export function getdata() {
    var obj = {
        searchlist: [
            {
                prop: "companyCode",
                label: '公司代码',
                type: "selectmore",
                width: "220px",
            },
            {
                prop: "shangpmc",
                label: '商品名称',
                type: "input",
            },
            {
                prop: "jzjtsuosq",
                label: '即征即退所属期',
                type: "datemonth",
                valueformat: 'yyyyMM'
            },
            {
                prop: "shuil",
                label: '税率',
                type: "select",
            },
            {
                prop: "financialAnnotations",
                label: '财务批注',
                type: "input",
            },
            {
                prop: "faplx",
                label: '发票类型',
                type: "select",
                selectval: comMapping.$fplx
            },
            {
                prop: "suosq",
                label: '发票所属期',
                type: "datemonth",
                valueformat: 'yyyyMM'
            },
            {
                prop: "fentfs",
                label: '分摊方式',
                type: "select",
                selectval: comMapping.$apportionmentMethod
            },
            {
                prop: "faphm",
                label: '发票号码',
                type: "input",
            },
            {
                prop: "beiz",
                label: '备注',
                type: "input",
            },
            {
                prop: "isLock",
                label: '是否锁定',
                type: "select",
                selectval: comMapping.$isLock
            },
        ],
        searchdata: {
            companyCode: "",
            shangpmc: "",
            jzjtsuosq: "",
            shuil: "",
            financialAnnotations: "",
            faplx: "",
            suosq: "",
            fentfs: "",
            faphm: "",
            beiz: "",
            isLock: "",
        },
        headData: [
            {
                title: "公司代码",
                prop: "companyCode",
                width: 80,
                custom: true
            },
            {
                title: "发票所属期",
                prop: "suosq",
                width: 80,
                custom: true
            },
            {
                title: "发票号码",
                prop: "faphm",
                width: 80, custom: true
            },
            {
                title: "税额合计",
                prop: "shuiehj",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "明细行",
                prop: "mingxbh",
                custom: true,
                width: 80,
            },
            {
                title: "商品名称",
                prop: "shangpmc",
                width: 90,
                custom: true
            },
            {
                title: "税收分类编码",
                prop: "shuisflbm",
                width: 110,
                custom: true
            },
            {
                title: "税率",
                prop: "shuil",
                width: 80,
                custom: true
            },
            {
                title: "未税金额",
                prop: "buhsje",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "税额",
                prop: "shuie",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "分摊税额",
                prop: "fentshuie",
                width: 80,
                AmountFormat: true,
                custom: true
            },
            {
                title: "分摊方式",
                prop: "fentfs",
                width: 80,
                custom: true
            },
            {
                title: "财务批注",
                prop: "financialAnnotations",
                width: 80,
                custom: true
            },
            {
                title: "备注",
                prop: "beiz",
                width: 80,
                custom: true
            },
        ],
        pagination: {
            pageNum: 1,
            pageSize: 50,
            total: 0,
            paginationkey: 0
        },
    }
    return obj
}
